import type { RequestInfo } from '@ember-data/request';
import { buildBaseURL, type QueryUrlOptions } from '@warp-drive/utilities';
import { SkipCache } from '@warp-drive/core-types/request';

/**
 * State-transition actions against `/tas-approvables`. The backend uses
 * the `state_transitionable` concern, so each transition is:
 *   PATCH /tas-approvables/:id/transition/state/:event_name  → 204
 *
 * - `abandon` — used when removing a receipt; the associated approvable
 *   is abandoned. Used by both employee + admin flows.
 * - `affirm` — admin-only. AFFIRMED is transitory: the backend
 *   `cascade_from_affirmed` callback decides the next step (back to
 *   PENDING for further review, or onward to APPROVED).
 * - `reject` — admin-only. Transitions PENDING → REJECTED.
 */
function transitionUrl(approvableId: string, event: string) {
  const opts: QueryUrlOptions = {
    identifier: { type: 'tas-approvables' },
    op: 'query',
    resourcePath: 'tas-approvables',
  };
  return `${buildBaseURL(opts)}/${approvableId}/transition/state/${event}`;
}

export function abandonTasApprovableRequest(approvableId: string): RequestInfo {
  return {
    url: transitionUrl(approvableId, 'abandon'),
    method: 'PATCH',
    cacheOptions: { [SkipCache]: true },
  };
}

export function affirmTasApprovableRequest(approvableId: string): RequestInfo {
  return {
    url: transitionUrl(approvableId, 'affirm'),
    method: 'PATCH',
    cacheOptions: { [SkipCache]: true },
  };
}

export function rejectTasApprovableRequest(approvableId: string): RequestInfo {
  return {
    url: transitionUrl(approvableId, 'reject'),
    method: 'PATCH',
    cacheOptions: { [SkipCache]: true },
  };
}
